import React from 'react';
import PropTypes from 'prop-types';
import './AutoFillModal.css';

function AutoFillModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isError,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="autofill-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="autofill-modal-content">
        <h2 id="modal-title" className="autofill-modal-title">
          {title}
        </h2>
        <p className="autofill-modal-message">{message}</p>
        <div className="autofill-modal-buttons">
          {!isError && (
            <button
              type="button"
              className="confirm-button"
              onClick={onConfirm}
              aria-label="Confirm auto-fill"
            >
              Sim, auto preencher
            </button>
          )}
          <button
            type="button"
            className="cancel-button"
            onClick={onClose}
            aria-label={isError ? 'Fechar' : 'Cancelar'}
          >
            {isError ? 'Fechar' : 'Cancelar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Adicionando validação de propriedades com PropTypes
AutoFillModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isError: PropTypes.bool,
};

// Definindo valores padrões para propriedades opcionais
AutoFillModal.defaultProps = {
  onConfirm: null,
  isError: false,
};

export default AutoFillModal;
